import React from 'react'
import GitHubButton from 'react-github-btn'
// import { LinkedinIcon } from 'components/LinkedinIcon'

interface StarRepoButtonProps {
    theme: string
}

export const StarRepoButton = ({ theme = 'light' }: StarRepoButtonProps) => (
    <span id="github-star-repo-btn">
        <GitHubButton
            href="https://github.com/icloud-ready/icloudready"
            data-icon="octicon-star"
            data-size="large"
            data-show-count={true}
            data-color-scheme={theme}
            aria-label="Star iCloudReady/icloudready on GitHub"
        >
            Star
        </GitHubButton>
        {/* <LinkedinIcon companyname="icloud-ready" /> */}
    </span>
)
